import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import SetPasswordModal from './SetPasswordModal';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSetPasswordModal, setShowSetPasswordModal] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      if (result.needsPasswordSetup) {
        // User needs to set initial password
        setShowSetPasswordModal(true);
      } else {
        // Normal login - close modal
        onClose();
        setEmail('');
        setPassword('');
      }
    } else {
      setError(result.error || 'Login failed');
    }
    
    setLoading(false);
  };

  const handleSetPasswordClose = () => {
    setShowSetPasswordModal(false);
    onClose(); // Close login modal after password is set
    setEmail('');
    setPassword('');
  };

  return (
    <>
      <div className="login-modal-overlay" onClick={onClose}>
        <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="login-modal-close" onClick={onClose}>×</button>
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="login-form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="login-form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="login-submit-btn">
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
      <SetPasswordModal isOpen={showSetPasswordModal} onClose={handleSetPasswordClose} />
    </>
  );
};

export default LoginModal;

